import React from "react";
import { useFormContext, useFormState } from "react-hook-form";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { ErrorMessage, RequiredMark } from "@components/inputs/shared";
import { CheckboxFieldProps } from "../types";
import { get } from "lodash";

export default function CheckboxField(props: CheckboxFieldProps) {
	const { t } = useTranslation();
	const { register } = useFormContext();
	const {
		label = "",
		name,
		checkboxClassname,
		id,
		errorMessage,
		required = false,
		customLabel,
		labelClassName,
		asterisksClass,
		...rest
	} = props;

	const { errors } = useFormState();
	const error = get(errors, name);

	const field = register(props.name, {
		required: {
			value: required,
			message: errorMessage || "COMMON.REQUIRED_FIELD",
		},
		disabled: props.disabled,
	});

	return (
		<>
			<div
				className={classNames("input--check", checkboxClassname, {
					"input--check--invalid": error != undefined,
				})}
			>
				<input
					id={id}
					className={classNames("input--check__box", {
						"input--check--invalid__box": error != undefined,
					})}
					type="checkbox"
					{...rest}
					{...field}
				/>

				<label
					htmlFor={id}
					className={classNames(
						"input--check__label",
						labelClassName,
						{
							"input--check--invalid__label": error != undefined,
						}
					)}
				>
					{customLabel ? (
						<>
							{customLabel}
							<RequiredMark
								required={required}
								asterisksClass={asterisksClass}
							/>
							<ErrorMessage
								name={name}
								customErrorClassName="input--check__validation message--validation message--validation--error"
							/>
						</>
					) : (
						<>
							{t(label)}{" "}
							<RequiredMark
								required={required}
								asterisksClass={asterisksClass}
							/>
						</>
					)}
				</label>

				{!customLabel && (
					<ErrorMessage
						name={name}
						customErrorClassName="input--check__validation message--validation message--validation--error"
					/>
				)}
			</div>
		</>
	);
}
